import { render, staticRenderFns } from "./OtpCard.vue?vue&type=template&id=105f431e&scoped=true"
import script from "./OtpCard.vue?vue&type=script&lang=js"
export * from "./OtpCard.vue?vue&type=script&lang=js"
import style0 from "./OtpCard.vue?vue&type=style&index=0&id=105f431e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105f431e",
  null
  
)

export default component.exports